import urlParameter from '@hc-frontend/shared-assets/src/js/utils/url/urlParameter'
import store from 'utils/store/withMiddleware'
import { IS_AGENT } from 'core/constants/environment'

const recommendedParam = urlParameter('recommended')

function resetFilters() {
  const {
    defaultFiltersByProductType,
    filtersByProductType,
    defaultPeriod,
    recEngine
  } = store.getState()

  Object.keys(defaultFiltersByProductType).forEach(keyType => {
    Object.keys(defaultFiltersByProductType[keyType]).forEach(filter => {
      filtersByProductType[keyType][filter] = defaultFiltersByProductType[keyType][filter]
    })
  })

  store.update({
    showRecommend: IS_AGENT ? !!recEngine : recommendedParam !== 'no',
    sortBy: '',
    filtersByProductType,
    filters: {
      benefits: [],
      type: [],
      deductible: {},
      coverage: {},
      price: {},
      coinsurance: {},
      moop: {},
      networkProvider: [],
      drug: [],
      period: defaultPeriod
    }
  })
}

export default resetFilters
